import React, { memo, useEffect, useState } from 'react';
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../models/stores/actions';
import { initRootRemSize, handleScroll } from '../utils';
import BasicDrawer from '../components/BasicDrawer';
import BasicModel from '../components/BasicModel';
import TelModel from '../components/TelModel';

import Header from './Header';
import Footer from './Footer';



const Layouts = memo(() => {
  const [ scrollNum, setScrollNum ] = useState(0);
  const [ getCHSTopVal, setCHSTopVal ] = useState(0);
  const dispatch = useDispatch();
  const { selectScrollNum, handleRecReSize } = actions;
  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const basicDrawerReducer = useSelector(({basicDrawerReducer}) => basicDrawerReducer);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleRecSize = () => {
    initRootRemSize({
      cab:(cwSize) => {
        const screenHeightVal = document.documentElement.clientHeight;
        dispatch(handleRecReSize({value: cwSize, screenHeight: screenHeightVal}));
      }
    });
    window.onresize = () => {
      const screenHeightVal = document.documentElement.clientHeight;
      initRootRemSize({
        cab:(cwSize) => {
          dispatch(handleRecReSize({value: cwSize, screenHeight: screenHeightVal }));
        }
      });
    }
  }


  // 既不能双击缩放，也不能双指缩放
  /* const initOnLoad = () => {
    window.onload= () => {
      document.addEventListener('touchstart',function (event) {
        if(event.touches.length>1){
          event.preventDefault();
        }
      });
      var lastTouchEnd=0;
      document.addEventListener('touchend',function (event) {
        var now=(new Date()).getTime();
        if(now-lastTouchEnd<=300){
          event.preventDefault();
        }
        lastTouchEnd=now;
      },false);
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault();
      });
    }
  } */

  useEffect(() => {
    handleRecSize();

    handleScroll({
      cab: ({scrollVal, cHSTopVal}) => {
        setScrollNum(scrollVal);
        setCHSTopVal(cHSTopVal);
      }
    });

    dispatch(selectScrollNum({value: scrollNum, cshVal: getCHSTopVal}));

    // initOnLoad();

    return () => {
      handleRecSize();
      handleScroll({
        cab: ({scrollVal, cHSTopVal}) => {
          setScrollNum(scrollVal);
          setCHSTopVal(cHSTopVal);
        }
      });
      dispatch(selectScrollNum({value: scrollNum, cshVal: getCHSTopVal}));
    }
  }, [dispatch, getCHSTopVal, handleRecSize, scrollNum, selectScrollNum]);


  const getWidthSize = () => {
    let val;
    if (recReSizeReducer > 1920) {
      val = 1340;
    } else if (recReSizeReducer > 1440 && recReSizeReducer <= 1920) {
      val = 1330;
    } else if (recReSizeReducer > 1024 && recReSizeReducer <= 1440) {
      val = 1200;
    } else if (recReSizeReducer > 750 && recReSizeReducer <= 1024) {
      val = 823;
    }
    return val;
  };

  // 打开弹窗后修改页面不让滚动
  useEffect(() => {
    const { visible, otherVisible} = basicDrawerReducer;
    const isFlag = visible || otherVisible;

    if(isFlag){
      document.documentElement.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    }else{
      document.documentElement.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'scroll';
    }
  }, [basicDrawerReducer]);

  const desktopMobile = () => {
    const { visible, otherVisible} = basicDrawerReducer;
    const isFlag = visible || otherVisible;
    const styles = {
      transition: 'all 1s',
      transform: `translate(-${isFlag ? getWidthSize() : 0}px, 0px)`,
    };

    const stylesModel = {
      transition: 'all 1s',
      transform: `translate(${isFlag ? 0 : 2340}px, 0px)`,
    };


    return (
      <>
        <Header 
          scrollNum={scrollNum}
          config={styles}
        />

        <div 
          className='main'
          style={styles}
        >
          <Outlet />
        </div>

        <Footer 
          config={styles}
        />

        <BasicDrawer
           config={{
             name: 'basic drawer',
             styles: stylesModel
           }}
         />
         <BasicModel
           config={{
             name: 'basic drawer',
             styles: stylesModel
           }}
         />
         <TelModel />
      </>
   );
  }

  return desktopMobile();
});

export default Layouts;